import Vue from 'vue'
import Vuex from 'vuex'
import textileColors from './store/textileColors'
import bagColors from './store/bagColors'
import textileSizes from './store/textileSizes'
import textileTypes from './store/textileTypes'
import textilePrint from './store/textilePrint'
import tShirts from './store/tShitrs'
import polo from './store/polo'
import sweatshirts from './store/sweatshirts'
import hoodies from './store/hoodies'
import baseballCaps from './store/baseballCaps'
import bags from './store/bags'
import density from './store/density'
import cart from './store/cart'
import order from './store/order'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    textileColors,
    bagColors,
    textileSizes,
    textileTypes,
    textilePrint,
    tShirts,
    polo,
    sweatshirts,
    hoodies,
    baseballCaps,
    bags,
    density,
    cart,
    order,
  },
  state: {
    stockManagement: false, // управление остатками (склад)
  },
  mutations: {

  },
  actions: {

  }
})
